import { Injectable } from '@angular/core';
import { JsonHttpService } from '../../shared/http/json-http.service';
import { AdvancedHttpHandlerEntity } from '../models/advanced-http-handler';
import { HttpParams } from '@angular/common/http';
import { DataFieldGroup, DataFieldValue } from 'src/app/shared/datafields/models';

@Injectable({
    providedIn: 'root'
})
export class AdvancedHttpHandlerService {

    constructor(private httpService: JsonHttpService) { }

    getAdvancedHttpHandlers(): Promise<AdvancedHttpHandlerEntity[]> {
        return this.httpService.get('/api/transport/advanced-http-handlers/get-advanced-http-handlers').toPromise();
    }

    saveAdvancedHttpHandler(entity: AdvancedHttpHandlerEntity, datafieldValues: DataFieldValue[]): Promise<AdvancedHttpHandlerEntity> {
        const saveObject = {
            AdvancedHttpHandler: entity,
            Values: datafieldValues
        };
        return this.httpService.post('/api/transport/advanced-http-handlers/save-advanced-http-handler', saveObject, null, false).toPromise();
    }

    deleteAdvancedHttpHandler(id: number) {
        const options = { params: new HttpParams().set('advancedHttpHandlerId', id.toString()) };
        return this.httpService.post('/api/transport/advanced-http-handlers/delete-advanced-http-handler', null, options, false).toPromise();
    }

    getAdvancedHttpHandlerDataFieldGroups(artifactId: string, httpHandlerId?: number): Promise<DataFieldGroup[]> {
        const options = { params: new HttpParams().set('artifactId', artifactId) };
        if (httpHandlerId) {
            options.params = options.params.set('advancedHttpHandlerId', httpHandlerId);
        }
        return this.httpService.get('/api/transport/advanced-http-handlers/get-advanced-http-handler-datafields', options).toPromise();
    }

    getBaseApiUrl(): Promise<string> {
        return this.httpService.get('/api/transport/advanced-http-handlers/get-base-api-url').toPromise();
    }
}
